(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurabreath-premium-bundles"] && !Shopify.designMode) return;
  try {
    
  const mountAuraBreathBundles = () => {
    const bundle = document.querySelector('[data-aurabreath-bundles]');
    const productInfo = document.querySelector('product-info') || document.querySelector('.product__info-container');
    const productTitle = productInfo?.querySelector('.product__title');
    const productHeading = productTitle?.querySelector('h1, h2');
    if (productHeading) {
      productHeading.style.setProperty('font-size', '2.3rem', 'important');
      productHeading.style.setProperty('font-weight', '800', 'important');
      productHeading.style.setProperty('line-height', '1.12', 'important');
    }
    const productPrice = productInfo?.querySelector('[id^="price-"]');
    const productBenefits = productInfo?.querySelector('.aurabreath-product-benefits');
    const bundleAnchor = productBenefits || productPrice || productTitle;

    if (bundle && bundleAnchor && bundleAnchor.nextElementSibling !== bundle) {
      bundleAnchor.insertAdjacentElement('afterend', bundle);
    }
  };

  mountAuraBreathBundles();
  document.addEventListener('shopify:section:load', mountAuraBreathBundles);

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-aurabreath-form]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-aurabreath-error]');
    const variantId = form.querySelector('[name="id"]').value;
    const quantity = Number(form.querySelector('[name="quantity"]:checked').value);
    const buttonLabel = button.querySelector('span');
    const originalLabel = buttonLabel.textContent;
    const cartUi = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    buttonLabel.textContent = 'Ajout en cours…';
    error.hidden = true;

    try {
      const requestBody = {
        updates: { [variantId]: quantity }
      };

      if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
        requestBody.sections = cartUi.getSectionsToRender().map((section) => section.id);
        requestBody.sections_url = window.location.pathname;
      }

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) throw new Error('cart');
      const cartState = await response.json();

      buttonLabel.textContent = quantity > 1 ? `${quantity} produits ajoutés ✓` : 'Produit ajouté ✓';

      if (cartUi && typeof cartUi.renderContents === 'function') {
        cartUi.renderContents(cartState);
      } else {
        window.location.assign('/cart');
        return;
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { source: 'aurabreath-bundles', cart: cartState }
      }));

      window.setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        buttonLabel.textContent = originalLabel;
      }, 1800);
    } catch (requestError) {
      error.textContent = 'Une erreur est survenue. Veuillez réessayer.';
      error.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      buttonLabel.textContent = originalLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (window.matchMedia('(min-width: 990px)').matches) {
        this.header.classList.toggle('aurastep-floating-active', scrollTop > 12);
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
